import { format } from 'date-fns'
import PropTypes from 'prop-types'
import CalendarTimeSettings from './CalendarTimeSettings'

const WeeklyCalendarHeader = ({
  currentWeek,
  navigateWeek,
  goToToday,
  startHour,
  endHour,
  savePreferences,
  resetPreferences,
  isDefault,
}) => (
  <div className="calendar-header">
    <div className="week-navigation">
      <button
        className="btn btn-secondary"
        onClick={() => navigateWeek('prev')}
      >
        ← Previous Week
      </button>
      <div className="week-info">
        <h3 className="week-display">
          Week of {format(currentWeek, 'MMM d, yyyy')}
        </h3>
        <button
          className="btn btn-primary btn-sm go-to-today"
          onClick={goToToday}
        >
          Go To Today
        </button>
      </div>
      <button
        className="btn btn-secondary"
        onClick={() => navigateWeek('next')}
      >
        Next Week →
      </button>
    </div>

    <div className="calendar-controls">
      <CalendarTimeSettings
        startHour={startHour}
        endHour={endHour}
        onSave={savePreferences}
        onReset={resetPreferences}
        isDefault={isDefault}
      />
    </div>

    <div className="calendar-legend">
      <div className="legend-item">
        <div className="legend-color user-available"></div>
        <span>Your Availability</span>
      </div>
      <div className="legend-item">
        <div className="legend-color opponent-available"></div>
        <span>Opponent Available</span>
      </div>
      <div className="legend-item">
        <div className="legend-color overlap-available"></div>
        <span>Overlapping Availability (click to view opponents)</span>
      </div>
      <div className="legend-item">
        <div className="legend-color pending-proposal"></div>
        <span>Has Proposals</span>
      </div>
      <div className="legend-item">
        <div className="legend-color scheduled-match"></div>
        <span>Scheduled Matches</span>
      </div>
      <div className="legend-item">
        <div className="legend-color completed-match"></div>
        <span>Completed Matches</span>
      </div>
    </div>
  </div>
)

WeeklyCalendarHeader.propTypes = {
  currentWeek: PropTypes.instanceOf(Date).isRequired,
  navigateWeek: PropTypes.func.isRequired,
  goToToday: PropTypes.func.isRequired,
  startHour: PropTypes.number.isRequired,
  endHour: PropTypes.number.isRequired,
  savePreferences: PropTypes.func.isRequired,
  resetPreferences: PropTypes.func.isRequired,
  isDefault: PropTypes.bool.isRequired,
}

export default WeeklyCalendarHeader
